import './EditorToolbar.51b2e2005a0888d200ace3ff123a550e.css';
export default {"toolbar":"_toolbar_1lvz7_1","sections":"_sections_1lvz7_1","item":"_item_1lvz7_1","active":"_active_1lvz7_1","section":"_section_1lvz7_1"};